import { Component, inject } from '@angular/core';
import { RouterLink } from "@angular/router";
import { PermissionService } from "../../../../services/permissions.service";
import { SubscriptionService } from "../../../../services/subscription.service";
import { computed } from '@angular/core';
import { AccountStatus } from '../../../../interfaces/account-status';

@Component({
  selector: 'app-header-account-info',
  imports: [
    RouterLink
  ],
  templateUrl: './header-account-info.component.html',
  styleUrl: './header-account-info.component.scss'
})
export class HeaderAccountInfoComponent {
  private readonly subscriptionService = inject(SubscriptionService);
  private readonly permissions = inject(PermissionService);

  readonly accountStatus = this.subscriptionService.accountStatus;

  constructor() {
    this.subscriptionService.initAccountStatus();
  }

  private getEndDate(accountStatus: AccountStatus | null): Date {
    if (!accountStatus) return new Date();
    const nextBillingDate = accountStatus.subscription.nextBillingDate;
    if (nextBillingDate) {
      const parsedDate = new Date(nextBillingDate);
      if (!isNaN(parsedDate.getTime())) {
        parsedDate.setDate(parsedDate.getDate() - 1);
        return parsedDate;
      }
    }
    return new Date();
  }

  readonly daysLeft = computed(() => {
    const accountStatus = this.accountStatus();
    if (!accountStatus) return 0;
    const endDate = this.getEndDate(accountStatus);
    const today = new Date();
    const diffTime = endDate.getTime() - today.getTime();
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    return Math.max(0, diffDays);
  });

  readonly expirationMessage = computed(() => {
    const days = this.daysLeft();
    if (days <= 1) return "This is your last day.";
    return `${days} days of your Free Trial remain.`;
  });

  readonly isPlanEnding = computed(() => {
    const accountStatus = this.accountStatus();
    console.log(accountStatus)
    if (!accountStatus) return false;
    const endDate = this.getEndDate(accountStatus);
    return accountStatus.subscription.isTrial && endDate && accountStatus.status === 'ok';
  });

  readonly canManageAccount = computed(() => {
    return this.permissions.getPermission('accountPermissions', 'manageAccount');
  });
}
